import React from 'react';
// import Header from'./Components/Header/Header'
import Header from './Components/Header/Header'
import Nav from './Components/Nav/Nav'
import About from './Components/about/About'
import Experience from './Components/Experience/Experience'
import Services from './Components/Services/Services'
import Project from './Components/Project/Project'
import Testimonial from './Components/Testmonial/Testimonial'
import Contact from './Components/Contact/Contact'
import Footer from './Components/Footer/Footer'
import Blog from './Components/blog/Blog';
const App = () => {
    return (
        <div>
        <Header></Header>
        <Nav></Nav>
        <About></About>
        <Experience></Experience>
        <Services></Services>
        <Project></Project>
        <Blog></Blog>
        <Testimonial></Testimonial>

        <Contact></Contact>
        <Footer></Footer>
        </div>
    );
};

export default App;